import React from 'react'
import {Route} from 'react-router-dom'
import Auth from './custom/auth'

export default [
  <Route exact path="/admin" component={Auth} noLayout />,
]
